import FieldInputController from './FieldInputController'

export default FieldInputController
